import { render, staticRenderFns } from "./DoubleColumnView.vue?vue&type=template&id=1932f8c8&scoped=true&"
import script from "./DoubleColumnView.vue?vue&type=script&lang=js&"
export * from "./DoubleColumnView.vue?vue&type=script&lang=js&"
import style0 from "./DoubleColumnView.vue?vue&type=style&index=0&id=1932f8c8&prod&lang=scss&scoped=true&"
import style1 from "./DoubleColumnView.vue?vue&type=style&index=1&id=1932f8c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1932f8c8",
  null
  
)

export default component.exports